// extracted by mini-css-extract-plugin
module.exports = {"root":"_37VDyKS","text":"X_2wFuE","profileButton":"_1L_gECz","candidate":"LakcNez","hirer":"_2xDx5Y_","employer":"_2jNlhUo","highlight":"_2py5Gel","teal":"_1JsoOSz","blue":"_23afq8N"};
    if(module.hot) {
      // 1545369458611
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  